import React from 'react';
import { getTranslation } from '../../../../../utils/translation';

export default function ResultTable({ total, debt, totalAgentCommission }) {
    return (
        <table className={'point-table h-full'}>
            <thead>
                <tr style={{ height: '21px' }} />
            </thead>
            <tbody>
                <tr align='left' className='reports-row'>
                    <td className='reports-leftCol'>
                        {getTranslation('balanceReportTotalColumn')}
                    </td>
                    <td>{total}</td>
                </tr>
                <tr align='left' className='reports-row'>
                    <td className='reports-leftCol'>
                        {getTranslation('balanceReportAgentCommissionColumn')}
                    </td>
                    <td>{totalAgentCommission}</td>
                </tr>
                <tr align='left' className='reports-row'>
                    <td className='reports-leftCol'>
                        {getTranslation('balanceReportSummaryTableDebtColumn')}
                    </td>
                    <td>{debt}</td>
                </tr>
            </tbody>
        </table>
    );
}
